import { getAppConfig } from './services/user';
import { App, FunctionalComponent, Component } from 'vue';
import { MessageApi } from 'ant-design-vue/lib/message';
import { message, Button, Card, Dropdown, Menu, Radio, Input, Tabs, Form, Modal } from 'ant-design-vue';

export interface AppKeyConf {
  themeKey: symbol,
  layoutKey: symbol,
  apiRoot?: string;
  passportUrl?:string;
  configurationServiceUrl?: string;
  frontendUrl?: string;
  // serverConfig:ServerConfig;
  hideLogin?:boolean;
}

export type Message = MessageApi;
export interface ServerConfig {
  'app_name': string | null;
  'app_version': string|null; // default: "1.0"
  'authenticationMethod': number | undefined;
}

interface ComponentList {
  name: string;
  component: FunctionalComponent | Component;
}
// 仅限于函数式组件
const list = [
  { name: '$message', component: message },
];

const comps = [
  Button,
  Card,
  Dropdown,
  Menu,
  Radio,
  Input,
  Tabs,
  Form,
  Modal,
];

function registryComponents<T>(app: App, list: Array<ComponentList>, comps: Array<any>) {
  // 注册全局函数组件, 在.vue内可通过inject(name)来调用，可通过引入类型声明来进行ts约束
  /**
   *  示例：
   *  import { Message } from 'relativePath/appConfig.ts'
   *  const message = inject('$message') as Message;
   *  message.info('提示信息');
   *  message.success('成功信息');
   */

  list.forEach(comp => {
    app.provide(comp.name as string, comp.component);
  });

  comps.forEach(comp => {
    app.use(comp);
  });
}

export default async function initAppConfig<T extends AppKeyConf>(app: App, opt: T) {
  const appConfig = await getAppConfig();
  console.log('appconf=', appConfig);
  if (appConfig.success) {
    app.provide(opt.themeKey, appConfig.data.theme);
    app.provide(opt.layoutKey, appConfig.data.layout);
  } else {
    message.error({
      content: appConfig.msg || '配置请求错误!',
    });
  }
  registryComponents(app, list, comps);
  // app.use(Antd);
  app.mount('#app');
  // 注册登录窗
}